import { Injectable } from '@angular/core';
import { SucursalApi } from '../../services/lbsdk/services/custom/Sucursal';
import { LoopBackFilter, UsuarioSucursalApi } from '../../services/lbsdk';
import { Sucursal } from '../../services/lbsdk/models/Sucursal';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

@Injectable()
export class UsuarioSucursalProvider {

  constructor(private usuarioSucursalApi: UsuarioSucursalApi,private authService: AuthService) {
    console.log('Hello CompaniesProvider Provider');
  }

  find(filter) {
    return this.usuarioSucursalApi.find(filter)
  }

  getOne(id: number): Observable<Sucursal> {
    let filter: any = { where: { id: id } };
    return this.usuarioSucursalApi.findOne(filter);
  }

  getById(id: number): Observable<Sucursal> {
    return this.usuarioSucursalApi.findById(id);
  }

  create(data: Sucursal): Observable<Sucursal> {
    return this.usuarioSucursalApi.create(data);
  }

  update(data: Sucursal): Observable<Sucursal> {
    return this.usuarioSucursalApi.patchAttributes(data.idsucursal, data);
  }

  delete(data: Sucursal): Observable<Sucursal> {
    return this.usuarioSucursalApi.deleteById(data.idsucursal);
  }
  
  count(filter) {
    return this.usuarioSucursalApi.count(filter)
  }

  
}



// WEBPACK FOOTER //
// ./src/providers/users/companies.provider.ts